import { Navbar as NavbarUi } from '@aqarmap/aqarmap-ui';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { useBreakpoint, useQuery } from '~/hooks';
import {
  useGetFavoriteCountQuery,
  useGetNotesCountQuery,
  useGetUserQuery,
} from '~/redux/api/userApiSlice';
import '~/components/Navbar/styles.css';
import { useGetNavbarLinksQuery } from '~/redux/api/appApiSlice';

export default function Navbar() {
  const { t } = useTranslation('app');
  const location = useLocation();
  const pathName = location.pathname;
  const locale = location.pathname.split('/')[1];
  const params = useQuery();
  const { mobileScreen } = useBreakpoint();
  const { data: navbarLinks } = useGetNavbarLinksQuery(undefined);
  const { data: responseData, isLoading: isUserLoading } = useGetUserQuery();
  const { data: favoriteCount, isLoading: isFavoriteLoading } =
    useGetFavoriteCountQuery();
  const { data: notesCount, isLoading: isNotesLoading } =
    useGetNotesCountQuery();

  return (
    <NavbarUi
      className="navbar navbar-constrained border-b !m-0 !p-0"
      translations={{
        aqarmapPackages: t('aqarmapPackages'),
        packagesBenefits: t('packagesBenefits'),
        pointsHistory: t('pointsHistory'),
        activities: t('activities'),
        adviceTips: t('adviceTips'),
        adviceTipsDescription: t('adviceTipsDescription'),
        alerts: t('alerts'),
        askNeighbors: t('askNeighbors'),
        askNeighborsDescription: t('askNeighborsDescription'),
        changeData: t('changeData'),
        compounds: t('compounds'),
        compoundsRating: t('compoundsRating'),
        compoundsRatingDescription: t('compoundsRatingDescription'),
        country: t('country'),
        dashboard: t('dashboard'),
        dashboardAccessWarning: t('dashboardAccessWarning'),
        dashboardLabel: t('dashboardLabel'),
        discover: t('discover'),
        exhibitsGuide: t('exhibitsGuide'),
        exhibitsGuideDescription: t('exhibitsGuideDescription'),
        favorite: t('favorite'),
        forRent: t('forRent'),
        forSale: t('forSale'),
        joinedSince: t('joinedSince'),
        know: t('know'),
        knowMore: t('knowMore'),
        knowMoreDescription: t('knowMoreDescription'),
        ksa: t('ksa'),
        language: t('language'),
        listYourProperty: t('listYourProperty'),
        listing: t('listing'),
        loggedOutMenuCaption: t('loggedOutMenuCaption'),
        login: t('login'),
        logout: t('logout'),
        management: t('management'),
        marketResearch: t('marketResearch'),
        marketResearchDescription: t('marketResearchDescription'),
        mortgage: t('mortgage'),
        myAccount: t('myAccount'),
        mySubscription: t('mySubscription'),
        new: t('new'),
        notes: t('notes'),
        notifications: t('notifications'),
        onlineExpos: t('onlineExpos'),
        pricesGuide: t('pricesGuide'),
        pricesGuideDescription: t('pricesGuideDescription'),
        properties: t('properties'),
        realEstateIndex: t('realEstateIndex'),
        realEstateIndexDescription: t('realEstateIndexDescription'),
        regionModalTitle: t('regionModalTitle'),
        signUp: t('signUp'),
        topAgents: t('topAgents'),
        topAgentsDescription: t('topAgentsDescription'),
        valuation: t('valuation'),
        valuationDescription: t('valuationDescription'),
      }}
      baseUrl={process.env.REACT_APP_BASE_URL}
      authBaseUrl={process.env.REACT_APP_AUTH_SVC_ENDPOINT}
      searchParams={new URLSearchParams(params).toString()}
      user={responseData?.user}
      isUserLoading={isUserLoading}
      isFavoriteLoading={isFavoriteLoading}
      isNotesLoading={isNotesLoading}
      favoriteCount={favoriteCount?.count}
      notesCount={notesCount?.count}
      locale={locale}
      pathName={pathName}
      mobileScreen={mobileScreen}
      LinkComponent={({ href, ...props }) => <a href={href} {...props}></a>}
      navbarLinks={navbarLinks}
      helpLink={`${process.env.REACT_APP_BASE_URL}/${locale}/feedback`}
    />
  );
}
